import { Navigate } from 'react-router-dom';
import { useSession } from '../lib/auth.js';

// AuthGuard wraps protected routes. While the session is loading we render a
// minimal spinner; once resolved we either pass through (logged in) or
// redirect to /signup (logged out).
export default function AuthGuard({ children, requireWorkspace = false, redirectIfNoWorkspace = '/workspace-setup' }) {
  const { workspaces, loading, error } = useSession();

  if (loading) {
    return (
      <div role="status" aria-live="polite" style={{ padding: 'var(--space-12)', textAlign: 'center', color: 'var(--fg-2)' }}>
        Loading…
      </div>
    );
  }

  if (error) {
    return (
      <div role="alert" style={{ padding: 'var(--space-12)', textAlign: 'center', color: 'var(--danger)' }}>
        Could not check session. Try refreshing.
      </div>
    );
  }

  if (workspaces === null) {
    return <Navigate to="/signup" replace />;
  }

  if (requireWorkspace && workspaces.length === 0) {
    return <Navigate to={redirectIfNoWorkspace} replace />;
  }

  return children;
}
